import type { SortingState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  SimpleTable as BaseSimpleTable,
  type SimpleTableProps,
} from "@volca/ui/components/ui/simple-table";

export * from "@volca/ui/components/ui/simple-table";

// @volca/ui's SimpleTable, with its sort order kept in the URL (?sort=&desc=),
// so a reload or a shared link keeps it.
export const SimpleTable = <TData,>(
  props: Omit<SimpleTableProps<TData>, "sorting" | "onSortingChange">,
) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const sorting = useMemo<SortingState>(() => {
    const sortParam = searchParams.get("sort");
    const descParam = searchParams.get("desc");
    return sortParam ? [{ id: sortParam, desc: descParam === "true" }] : [];
  }, [searchParams]);

  const onSortingChange = (next: SortingState) => {
    if (next[0]) {
      searchParams.set("sort", next[0].id);
      searchParams.set("desc", next[0].desc ? "true" : "false");
    } else {
      searchParams.delete("sort");
      searchParams.delete("desc");
    }
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <BaseSimpleTable
      {...props}
      sorting={sorting}
      onSortingChange={onSortingChange}
    />
  );
};
